module.exports = function(a){
	return !!(a && a.apply);
}